import { render, staticRenderFns } from "./manFormList.vue?vue&type=template&id=383e2445&scoped=true"
import script from "./manFormList.vue?vue&type=script&lang=js"
export * from "./manFormList.vue?vue&type=script&lang=js"
import style0 from "./manFormList.vue?vue&type=style&index=0&id=383e2445&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e2445",
  null
  
)

export default component.exports